import { render, staticRenderFns } from "./subscribeDetailDialog.vue?vue&type=template&id=530be2f3&scoped=true"
import script from "./subscribeDetailDialog.vue?vue&type=script&lang=js"
export * from "./subscribeDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./subscribeDetailDialog.vue?vue&type=style&index=0&id=530be2f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530be2f3",
  null
  
)

export default component.exports